import { render, staticRenderFns } from "./SettingCompensation.vue?vue&type=template&id=3ed05440&"
import script from "./SettingCompensation.vue?vue&type=script&lang=js&"
export * from "./SettingCompensation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports